var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useEffect, useState, useRef } from 'react';
import DomInspectorBase from './base';
import useLocale from '@src/hooks/useLocale';
import locale from './locale';
import CSSText from './css';
import './style.css';
var DomInspector = function DomInspector(props) {
  var iframeLoaded = props.iframeLoaded,
    enable = props.enable,
    frame = props.frame;
  var _a = __read(useState(null), 2),
    dom = _a[0],
    setDom = _a[1];
  var inspectorRef = useRef(null);
  var t = useLocale(locale).t;
  useEffect(function () {
    var dom;
    if (iframeLoaded && (frame === null || frame === void 0 ? void 0 : frame.document)) {
      dom = frame.document.body;
      frame.onhashchange = function () {
        var _a;
        (_a = inspectorRef === null || inspectorRef === void 0 ? void 0 : inspectorRef.current) === null || _a === void 0 ? void 0 : _a.fresh();
      };
      setDom(dom);
      var styleTag = document.createElement('style');
      styleTag.textContent = CSSText;
      frame.document.body.appendChild(styleTag);
    }
  }, [iframeLoaded]);
  var baseInfoList = [{
    label: t['inspector.basicType'],
    type: 'baseStyle',
    value: t['inspector.basicTypeValue']
  }, {
    label: t['inspector.boxSize'],
    type: 'boxSize'
  }, {
    label: t['inspector.fontSize'],
    type: 'fontSize'
  }, {
    label: t['inspector.color'],
    type: 'color'
  }, {
    label: t['inspector.backgroundColor'],
    type: 'backgroundColor'
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, iframeLoaded && dom ? /*#__PURE__*/React.createElement(DomInspectorBase, {
    ref: inspectorRef,
    enable: enable,
    root: dom,
    theme: 'arco-inspector',
    maxZIndex: '6000',
    exclude: ['demo-item', 'demos-wrapper', 'arco-space', 'arco-space-item', 'component-demo-btn', 'component-demo-list', 'inspector-switch', 'inspector-text', 'demo-page-preview'],
    baseInfoList: baseInfoList
  }) : null);
};
export default DomInspector;